import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations, defaultLanguage, languages } from '../data/mockData';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [currentLang, setCurrentLang] = useState(() => {
    const saved = localStorage.getItem('boidy-language');
    return saved && translations[saved] ? saved : defaultLanguage;
  });

  const [isRTL, setIsRTL] = useState(false);

  useEffect(() => {
    localStorage.setItem('boidy-language', currentLang);
    const langConfig = languages.find(l => l.code === currentLang);
    setIsRTL(langConfig?.rtl || false);
    document.documentElement.dir = langConfig?.rtl ? 'rtl' : 'ltr';
    document.documentElement.lang = currentLang;
  }, [currentLang, languages]);

  const t = translations[currentLang] || translations[defaultLanguage];

  const changeLang = (langCode) => {
    if (translations[langCode]) {
      setCurrentLang(langCode);
    }
  };

  return (
    <LanguageContext.Provider value={{ currentLang, changeLang, t, isRTL, languages }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;
